import { Component, Input } from '@angular/core';
import { Menu } from '../../services/site.model';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    // @Input() menus = [];
    //
    // ngOnInit() {
    // }
    //
    // moveUrl(menu) {}
}
